import React from 'react';
const ProductItemTitles = (props) => {
  const columnWidth = props.titlesList?.length > 0 ? 100 / props.titlesList.length : 100;
  return (
    <div className='productAndServicesItemContainer_titles blackShadeColor'>
      {props.titlesList?.map((title, index) => {
        return (
          <span className='' key={index} style={{width: `${props.widthList[index]}%`}}>
            {title}
          </span>
        );
      })}
    </div>
  );
};
export default ProductItemTitles;
